import eachOf from '../eachOf';

export default function doParallel(fn) {
    return function (obj, iteratee, callback) {
        return fn(eachOf, obj, iteratee, callback);
    };
}



// WEBPACK FOOTER //
// ../../../../~/async-es/internal/doParallel.js